import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import NoticeBanner from "../../components/NoticeBanner";

interface Props {
  open: boolean;
  messages: string[];
  onClose: () => void;
}

const ErrorMessageBanner: React.FC<Props> = ({
  open,
  messages,
  onClose
}) => {

  const [messageList, setMessageList] = useState<string[]>([])

  useEffect(() => {
    const list: string[] = []
    messages.forEach((message: string) => {
      if (message.includes("\n")) {
        message.split("\n").forEach((sentence: string) => {
          list.push(sentence)
        })
      } else {
        list.push(message)
      }
    })
    setMessageList(list)
  }, [messages])

  return (
    <Box sx={styles.container}>
      <NoticeBanner
        open={open}
        message={
          messageList.map((message: string, index: number)=> (
            <p style={{ margin: 0 }} key={`error_${index}`}>
              {message}
            </p>
          ))
        }
        type="error"
        onClose={onClose}
      />
    </Box>
  );
};
export default ErrorMessageBanner

const styles = {
  container: {
    position: "fixed",
    left: "5%",
    width: "90%",
    bottom: "12px",
    zIndex: 9999
  }
}
